<template>
  <div class="WImageUpload">
    <div class="file-list">
      <el-scrollbar ref="scrollbar">
        <div
          v-for="(item, index) in itemValue.data"
          :key="index"
          class="file-item"
        >
          <div class="float-tool-bar" v-if="!disabled && !formDisabledValue">
            <el-button
              type="text"
              icon="el-icon-view"
              @click="handleImgPreview(index)"
            ></el-button>
            <el-button
              type="text"
              icon="el-icon-delete"
              @click="handleDelete(index)"
            ></el-button>
          </div>
          <el-image
            :ref="'img-' + index"
            :src="item.src || item.thumbnail"
            fit="contain"
            lazy
            @error="handleError(item)"
            @click.native="handleImgPreview(index)"
          ></el-image>
        </div>
      </el-scrollbar>
    </div>
    <div
      class="upload"
      @click="handleInput"
      v-if="!disabled && !formDisabledValue"
    >
      <el-button icon="el-icon-plus"></el-button>
    </div>
    <input
      class="inputer"
      type="file"
      multiple
      :accept="accept"
      @change="handleFileChange"
      ref="inputer"
    />
    <ImageViewer
      v-if="visible"
      ref="imageViewer"
      :previewType="previewType"
      @closed="handleClosed"
    />
  </div>
</template>

<script>
import ImageViewer from '@/components/ImageViewer'
import { downloadFile } from '@/api/largeFile.js'
import upload from './mixin/upload'
export default {
  name: 'WImageUpload',
  mixins: [upload],
  components: {
    ImageViewer
  },
  props: {
    display: {
      type: String,
      default: 'single'
    },
    accept: {
      type: String,
      default: '*'
    },
    size: {
      type: Number,
      default: 0
    },
    limit: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      uploadLimit: 0,
      fileList: [],
      url: undefined,
      formData: undefined,
      files: []
    }
  },
  mounted() {
    this.getImg()
  },
  methods: {
    handleImgPreview() {
      this.visible = true
      this.value.data.forEach(d => {
        this.$set(d, 'thumbnail', d.src)
        this.$set(d, 'src', '')
      })
      this.$nextTick(() => {
        this.$refs.imageViewer.previewAttach(this.value.data)
      })
    },
    // 删除图片
    handleDelete(index) {
      this.itemValue.data.splice(index, 1)
      this.$emit('handleUpdate')
    },
    // 图片预览
    handlePreview(index) {
      const ref = 'img-' + index
      this.$refs[ref][0].clickHandler()
    },
    handleInput() {
      this.$refs.inputer.click()
    },
    handleFileChange() {
      const inputDOM = this.$refs.inputer
      this.files = []
      for (let i = 0; i < inputDOM.files.length; i++) {
        if (this.beforeUpload(inputDOM.files[i])) {
          this.files.push(inputDOM.files[i])
        }
      }

      this.handleUpload(this.files)
      inputDOM.value = null
    }
  }
}
</script>

<style lang="scss">
.WImageUpload {
  height: 100%;
  width: 100%;
  .el-image {
    cursor: pointer;
  }
}
.WImageUpload::after {
  content: "";
  clear: both;
}
.WImageUpload .file-list {
  float: left;
  max-width: calc(100% - 68px);
  margin-right: 10px;
}
.WImageUpload .upload {
  height: 58px;
  width: 58px;
  text-align: center;
  float: left;
}
.WImageUpload .el-button {
  width: 100%;
  height: 100%;
  font-size: 24px;
  padding: 0;
  position: relative;
  /* margin: 0 10px 0 0; */
}
.WImageUpload .el-button img {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  max-width: 100%;
  max-height: 100%;
  display: block;
  vertical-align: middle;
  text-align: center;
  margin: auto;
}
.WImageUpload .file-item {
  display: inline-block;
  height: 58px;
  width: 58px;
  text-align: center;
  border-radius: 3px;
  overflow: hidden;
  position: relative;
  &:hover .float-tool-bar {
    display: block;
  }
  .float-tool-bar {
    display: none;
    position: absolute;
    z-index: 2;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    text-align: center;
    &::after {
      content: "";
      display: block;
      position: absolute;
      top: 0;
      right: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.4);
      z-index: 2;
    }
    .el-button {
      width: auto;
      color: #fff;
      margin: 0 1px;
      font-size: 16px;
      position: relative;
      z-index: 3;
    }
  }
}
.WImageUpload .file-item + .file-item {
  margin-left: 10px;
}
.WImageUpload .file-item .el-image {
  width: 100%;
  height: 100%;
  z-index: 1;
}

.WImageUpload .inputer {
  display: none;
}
.WImageUpload .el-scrollbar {
  height: 100%;
  width: 100%;
}
.WImageUpload .el-scrollbar__view {
  white-space: nowrap;
}
</style>